import { Icon, IconPropsStrict } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode, useCallback, useMemo } from 'react';
import * as Styles from './fake-input.module.less';

export interface FakeInputProps {
    value?: string;
    className?: string;
    active?: boolean;
    clearable?: boolean;
    disabled?: boolean;
    empty?: boolean;
    height?: number;
    leftIconName?: IconPropsStrict['name'];
    rightIconName?: IconPropsStrict['name'];
    children?: ReactNode;
    onClick?(): void;
    onClear?(): void;
}

export const FakeInput: FC<FakeInputProps> = ({
    active,
    children,
    className,
    clearable,
    disabled,
    empty,
    height,
    leftIconName,
    onClear,
    onClick,
    rightIconName,
    value,
}) => {
    const inputStyles = useMemo(() => (height ? { height: `${height}px` } : undefined), [height]);

    const onClearValues = useCallback(
        (e: MouseEvent) => {
            e.stopPropagation();
            e.preventDefault();

            if (onClear) {
                onClear();
            }
        },
        [onClear]
    );

    return (
        <div
            className={classNames(
                Styles.input,
                { [Styles.inputActive]: active },
                'border border-radius-1 d-f flex-row align-items-center',
                className
            )}
            style={inputStyles}
            onClick={onClick}
        >
            {!!leftIconName && (
                <Icon className="c-neutral-90 m-r-1" name={leftIconName} size={20} />
            )}

            <div
                className={classNames('flex-grow-1 flex-basis-0 min-w-0', {
                    'opacity-disabled': disabled,
                    [Styles.placeholder]: empty,
                })}
            >
                {children ?? value ?? ''}
            </div>

            {!!clearable && (
                <Icon
                    className="c-neutral-90 m-l-1"
                    name="close"
                    size={16}
                    onClick={onClearValues}
                />
            )}
            {!!rightIconName && (
                <Icon className="c-neutral-90 m-l-1" name={rightIconName} size={20} />
            )}
        </div>
    );
};
